import styled, { CSSObject } from 'styled-components';
import { Size, Color } from './types';

interface TextStyledProps {
  size?: keyof typeof Size;
  color?: keyof typeof Color;
  crossed?: boolean;
  error?: boolean;
  mr?: number;
  ml?: number;
  sx?: CSSObject;
}
// TODO: alex add color mapping
export const TextStyled = styled.span<TextStyledProps>(
  ({ theme, size, crossed, error, mr, ml, sx }) => ({
    color: error && theme.color.wfRed,
    textDecoration: crossed && 'line-through',
    textDecorationColor: crossed && theme.color.wfRed,
    fontSize: size === 'inherit' ? size : theme.font.size[size],
    fontWeight: theme.font.weight.nomral,
    marginRight: theme.space[mr],
    marginLeft: theme.space[ml],
    ...sx,
  }),
);
